import { EventTypes, useEditor } from '@candulabs/craft';
import React, { RefCallback } from 'react';

import { toCssSelector } from '@candu-ai/stylesheet/utils';
import { useTooltipPlacement } from 'craft/hooks';

export const Beacon = ({
  variant,
  nodeId,
  beaconRef,
}: {
  nodeId: string;
  variant?: string;
  beaconRef?: RefCallback<HTMLDivElement>;
}) => {
  const { actions } = useEditor();
  const { placement } = useTooltipPlacement(nodeId);

  const beaconClassName = toCssSelector('h-beacon', {
    output: 'html',
    variant: variant ? { variant } : undefined,
  });

  if (!placement?.selector) {
    return null;
  }

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <div
      id={`hotspot-beacon-wrapper-${nodeId}`}
      ref={beaconRef}
      className={beaconClassName}
      data-craft-ignore-events
      css={{ position: 'relative' }}
      onClick={(e) => {
        e.stopPropagation();
        actions.setEventNodes(EventTypes.selected, [nodeId]);
      }}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none">
        <circle className="animation" cx="16" cy="16" r="9" stroke="#6310E5" strokeWidth="2" />
        <circle className="outer" cx="16" cy="16" r="9" stroke="#6310E5" strokeWidth="2" />
        <circle className="inner" cx="16.0043" cy="15.9999" r="5.6" fill="#6310E5" />
      </svg>
    </div>
  );
};
